import blog1 from "../../Assets/images/blog-1.png";
import blog2 from "../../Assets/images/blog-2.png";
import blog3 from "../../Assets/images/blog-3.png";

// ourStatistics

import icon1 from "../../Assets/images/check.png";
import icon2 from "../../Assets/images/van.png";
import icon3 from "../../Assets/images/Shape.png";
import icon4 from "../../Assets/images/user.png";

export const latestNews = [
  {
    _id: 1,
    img: blog1,
    title: "Laser Cut Unstitched",
    description:
      "Lorem Ispum is a placeholder text commomly used as a free text.",
    date: "12 April 2023",
  },
  {
    _id: 2,
    img: blog2,
    title: "Laser Cut Unstitched",
    description:
      "Lorem Ispum is a placeholder text commomly used as a free text.",
    date: "03 April 2023",
  },
  {
    _id: 3,
    img: blog3,
    title: "Laser Cut Unstitched",
    description:
      "Lorem Ispum is a placeholder text commomly used as a free text.",
    date: "28 April 2023",
  },
];

export const ourStatistics = [
  {
    title: "Easy Order System ",
    description:
      "Lorem Ispum is a placeholder text commomly used as a free text.",
    icons: icon1,
    id: 1,
  },
  {
    title: "On Time Delievery",
    description:
      "Lorem Ispum is a placeholder text commomly used as a free text.",
    icons: icon2,
    id: 2,
  },
  {
    title: "Money Back Gaurantee",
    description:
      "Lorem Ispum is a placeholder text commomly used as a free text.",
    icons: icon3,
    id: 3,
  },
  {
    title: "24/7 Customer Support ",
    description:
      "Lorem Ispum is a placeholder text commomly used as a free text.",
    icons: icon4,
    id: 4,
  },
];
